/**
 * Returns true if a path exists in an array of paths
 *
 * @param currentPath {String} Path to check (usually the current location)
 * @param paths {Array} Array of paths
 * @return {Boolean}
 */
function pathContainsMatch(currentPath: string, paths: string[] = []): boolean {
  if (currentPath && typeof currentPath === 'string') {
    return paths.some(path => currentPath.indexOf(path) >= 0);
  }
  return false;
}

// eslint-disable-next-line import/prefer-default-export
export { pathContainsMatch };
